<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div class="matTitulo">
		<i class="fas fa-edit" id="ico"></i>
		<h1 style="display:inline-block;">Modificar Contraseña</h1>
	</div>
	<mat-divider></mat-divider>
</div>
<div class="kt-portlet">
	<div class="kt-portlet__head">
		<div class="encabezado mt-3">
			<h1 class="titulo"><span style="color: #646c9a;">{{user.nombreCompleto}}</span></h1>
		</div>
	</div>
	<div class="kt-portlet__body">
		<form [formGroup]="usuarioForm">
			<div class="row">
				<div class="col-md-12">
					<mat-form-field class="example-full-width mt-2">
						<mat-label>Contraseña Actual</mat-label>
						<input matInput type="password" formControlName="PasswordActual" autocomplete="off">
						<span matPrefix><i class="fas fa-lock"></i>&nbsp;</span>
						<mat-error *ngIf="usuarioForm.get('PasswordActual').invalid">Campo requerido</mat-error>
					</mat-form-field>
				</div>
				<div class="col-md-12">
					<mat-form-field class="example-full-width mt-2">
						<mat-label>Nueva Contraseña</mat-label>
						<input matInput type="password" formControlName="PasswordNuevo" autocomplete="off">
						<span matPrefix><i class="fas fa-key"></i>&nbsp;</span>
						<mat-error *ngIf="usuarioForm.get('PasswordNuevo').invalid">Campo requerido</mat-error>
					</mat-form-field>
				</div>
				<div class="col-md-12">
					<mat-form-field class="example-full-width mt-3">
						<mat-label>Confirmar Contraseña</mat-label>
						<input matInput type="password" formControlName="ConfirmarPassword" autocomplete="off">
						<span matPrefix><i class="fas fa-key"></i>&nbsp;</span>
						<mat-error *ngIf="usuarioForm.get('ConfirmarPassword').invalid">Las contraseñas no coinciden
						</mat-error>
					</mat-form-field>
				</div>
				<div class="mt-3">
					<span>* La contraseña no debe ser menor a 6 caracteres y no mayor a 15 caracteres.</span><br>
					<span>** Se recomienda por seguridad use combinacion de letras mayúsculas, minúsculas, números,
						símbolos.</span>
				</div>
			</div>
			<div class="kt-portlet__foot mt-3">
				<div class="kt-form__actions kt-form__actions mt-3">
					<button mat-raised-button color=primary (click)="modificarDatos()"
						[disabled]="usuarioForm.invalid"><i class="fas fa-save"></i>&nbsp;Guardar</button>
				</div>
			</div>
		</form>
	</div>
</div>
